import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-contract',
  templateUrl: './create-contract.component.html',
  styleUrls: ['./create-contract.component.css']
})
export class CreateContractComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
